import Common from '../common'
var Js = Common('message')
export default {
	name: 'message',
	mixins: [Js],
	components: {},
	data() {
		return {
			fields: [{
					key: 'id',
					label: 'ID',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
					width: 50
				},
				{
					key: "behavior",
					label: '状态',
					application: ['编辑'],
					componentName: 'sls-select',
					optionsName: 'behaviorOptions',
					listType: 'normal',
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					formatter: function(val) {
						if (val.behavior == 1) {
							return '已审核';
						} else {
							return '未审核';
						};
					},
					header_search: {
						componentName: 'sls-select',
						optionsName: 'behaviorOptions',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请选择菜单',
						changeFunc: function(val, self) {
							if (val||val==0) {
								console.log(val)
								self.searchItem.behavior = val;
								
							} else {
								delete self.searchItem.behavior;
							};
							
						},
					}
				},
				{
					key: 'name',
					label: '姓名',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入姓名',
						clearable: true,
						defaultValue: '',
						optionsName: '',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.name = val;
							} else {
								delete self.searchItem.name;
							};

						},
					},

				},
				{
					key: 'personPhone',
					label: '手机号',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入手机号',
						clearable: true,
						defaultValue: '',
						optionsName: '',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.personPhone = val;
							} else {
								delete self.searchItem.personPhone;
							};

						},
					},

				},
				{
					key: 'receiveCode',
					label: '收据编号',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'city',
					label: '参会城市',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入城市',
						clearable: true,
						defaultValue: '',
						optionsName: '',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.city = ['like',['%'+val+'%']];
							} else {
								delete self.searchItem.city;
							};
					
						},
					},
				},
				{
					key: 'artName',
					label: '课题名称',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					
				},
				{
					key: "type",
					label: '开票类型',
					application: [],
					componentName: 'sls-input',
					formatter: function(val) {
						if (val.type == 1) {
							return '增值税电子普票';
						} else {
							return '增值税专用发票';
						};
					}
				},
				{
					key: 'title',
					label: '单位名称',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'description',
					label: '纳税人识别号',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'keywords',
					label: '单位地址',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'phone',
					label: '单位电话',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'passage1',
					label: '开户行名称',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'passage2',
					label: '开户行账号',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'project',
					label: '开票项目',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'price',
					label: '开票金额',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'tip',
					label: '备注',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'address',
					label: '邮箱/地址',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'expressName',
					label: '物流公司',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'expressCode',
					label: '物流单号',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: "status",
					label: '状态',
					application: [],
					componentName: 'sls-select',
					optionsName: 'statusOptions',
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					formatter: function(val) {
						if (val.status == 1) {
							return '启用';
						} else {
							return '关闭';
						};
					}
				},
				
				{
					key: 'create_time',
					label: '创建时间',
					listType: 'normal',
					placeholder: '请选择创建时间',
					header_search: {
						componentName: 'sls-date-time-range',
						style: 'width:160px;margin-right:2px;',
						start_placeholder: '创建开始时间',
						end_placeholder: '创建结束时间',
						changeFunc: function(value, self) {
							if (!value) {
								delete self.searchItem.create_time;
							} else {
								self.searchItem.create_time = ['between', value = value.map(function(e) {
									return e / 1000;
								})]
							};

						},
					},
					width: 200,
				},
				{
					label: '操作',
					listType: 'deal',
					width: 200
				},
			],
			// 按钮配置
			btn_info: [


				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑'
					},
					func: {
						apiName: function(self) {
							return "api_messageUpdate"
						},
						formData: function(self) {
							return self.formData
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
								},
								data: self.submitData
							};
							if (self.submitData.parentid && self.submitData.parentid == self.formData.id) {
								self.$$notify('父级ID和子级ID重叠', 'fail');
								return false;
							} else {
								return postData;
							};

						}
					},
				},

				{
					type: 'danger',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '删除选中'
					},
					func: {

						apiName: function(self) {
							return "api_messageUpdate"
						},

						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
								},
								data: {
									status: -1
								}
							};
							return postData;
						}

					},
				},

				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'header',
					text: function(data) {
						return '添加'
					},
					func: {
						apiName: function(self) {
							return "api_messageAdd"
						},
						formData: function(self) {
							var data = {
								title: '',
								phone: '',
								content: '',
							};
							return data
						},
						postData: function(self) {
							self.submitData.type = 1;
							var postData = {
								data: self.submitData
							};
							return postData;
						}
					},
				},
				{
					type: 'primary',
					icon: 'edit',
					size: 'mini',
					position: 'header',
					func: {
						func: function(self) {
							self.uploadClick(self);
						},
					},
					text: function(data) {
						return '导入'
					},
					funcType: 'func',
				},
				{
					type: 'primary',
					icon: 'edit',
					size: 'mini',
					position: 'header',
					func: {
						func: function(self) {
							self.excelOutput(self);
						},
					},
					text: function(data) {
						return '导出'
					},
					funcType: 'func',
				},
			],

			searchItem: {},
			startSearchItem: {},
			optionData: {
				labelOptions: [],
				statusOptions: [{
					text: '启用',
					value: 1
				}, {
					text: '禁用',
					value: -1
				}],
				behaviorOptions: [{
					text: '未审核',
					value: 0
				}, {
					text: '已审核',
					value: 1
				}],
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				fixSearchItem: {
					status: 1
				},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			}

		}

	},

	mounted() {
		const self = this;
		self.searchData = self.$$cloneForm(self.searchItem);
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	methods: {

		/**
		 * 初始化
		 */
		init() {
			this.initMainData();
		},


		async excelOutput(self) {

			if (self.btnName == '导出') {
				const postData = {};
				postData.token = self.$store.getters.getToken;
				if (self.searchItem) {
					postData.searchItem = self.$$cloneForm(self.searchItem)
				};
				postData.excelOutput = {
					expTitle: 'test',
					expCellName: [{
							title: 'ID',
							key: ['id'],
							type: 'string',
						},
						{
							title: '姓名',
							key: ['name'],
							type: 'string',
						},
						{
							title: '电话',
							key: ['personPhone'],
							type: 'string',
						},
						{
							title: '收据编号',
							key: ['receiveCode'],
							type: 'string',
						},
						{
							title: '课题名称',
							key: ['artName'],
							type: 'string',
						},
						{
							title: '参会城市',
							key: ['city'],
							type: 'string',
						},
						{
							title: '单位名称',
							key: ['title'],
							type: 'string',
						},
						{
							title: '纳税人识别号',
							key: ['description'],
							type: 'string',
						},
						{
							title: '单位地址',
							key: ['keywords'],
							type: 'string',
						},
						{
							title: '单位电话',
							key: ['phone'],
							type: 'string',
						},
						{
							title: '开户行',
							key: ['passage1'],
							type: 'string',
						},
						{
							title: '开户行账号',
							key: ['passage2'],
							type: 'string',
						},
						{
							title: '开票项目',
							key: ['project'],
							type: 'string',
						},
						{
							title: '1.电子普票2.专用发票',
							key: ['type'],
							type: 'string',
						},
						{
							title: '开票金额',
							key: ['price'],
							type: 'string',
						},
						{
							title: '备注',
							key: ['tip'],
							type: 'string',
						},
						{
							title: '邮箱/地址',
							key: ['address'],
							type: 'string',
						},
						{
							title: '快递公司',
							key: ['expressName'],
							type: 'string',
						},
						{
							title: '快递单号',
							key: ['expressCode'],
							type: 'string',
						},
					],
					fileName: 'test'
				};

				window.open('https://zcbp13910080117.com/251/public/index.php/api/v1/Common/Message/get?token=' +
					postData.token +
					'&searchItem=' +
					JSON.stringify(postData.searchItem) +
					'&excelOutput=' +
					JSON.stringify(postData.excelOutput))
			}
		},

		uploadClick() {
			const self = this;
			self.$refs.uploadInput.click();
		},

		async upload(e) {

			const self = this;
			let file = e.target.files[0];
			var obj = file.name.lastIndexOf(".");
			var ext = file.name.substr(obj + 1);
			let param = new FormData() // 创建form对象

			param.append('excel', file, file.name) // 通过append向form对象添加数据
			param.append('excelChangeKey', JSON.stringify({
				'ID': 'id',
				'姓名':'name',
				'电话':'personPhone',
				'单位名称': 'title',
				'纳税人识别号': 'description',
				'单位地址': 'keywords',
				'单位电话': 'phone',
				'开户行': 'passage1',
				'开户行账号': 'passage2',
				'开票项目': 'project',
				'邮箱/地址': 'address',
				'快递公司': 'expressName',
				'快递单号': 'expressCode',
				'收据编号': 'receiveCode',
				'课题名称': 'artName',
				'参会城市': 'city',
				'开票金额': 'price',
				'1.电子普票2.专用发票':'type',
				'备注':'tip'
			}));
			param.append('token', self.$store.getters.getToken);
			param.append('ext', ext);
			param.append('md5', 'md5');
			param.append('totalSize', file.size);
			param.append('start', 0);
			param.append('chunkSize', file.size);
			param.append('originName', file.name);
			let config = {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}
			try {
				var res = await self.$$api_importExcel({
					data: param,
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				});
				if (res.solely_code == 100000) {
					self.$$notify('导入成功', 'success');
					this.initMainData(true);
				} else {
					self.$$notify(res.msg, 'fail');
				};
				self.$refs.uploadInput.value = '';
			} catch (e) {
				self.$refs.uploadInput.value = '';
			}
		},

		/**
		 * 列表主函数
		 */
		async initMainData(isNew) {

			const self = this;
			const postData = {};
			if (isNew) {
				self.paginate.currentPage = 1;
			};
			postData.paginate = self.$$cloneForm(self.paginate);
			postData.token = self.$store.getters.getToken;
			if (self.searchItem) {
				postData.searchItem = self.$$cloneForm(self.searchItem)
			};
			if (JSON.stringify(self.getBefore) != "{}") {
				postData.getBefore = self.$$cloneForm(self.getBefore);
			};
			postData.getAfter = {
				user: {
					tableName: 'User',
					middleKey: 'user_no',
					key: 'user_no',
					condition: '=',
					info: ['nickname', 'headImgUrl']
				},
				art: {
					tableName: 'Article',
					middleKey: 'relation_id',
					key: 'id',
					condition: '=',
					info: ['title', 'small_title']
				}
			}
			var res = await self.$$api_messageGet({
				data: postData
			});
			self.mainData = res.info.data;
			self.paginate.count = res.info.total;

		}

	},


}



// WEBPACK FOOTER //
// ./src/views/content/message.js